export const STORE_SPECIAL = 'store:special'
export const STORE_TEST_TAG = 'store:test'
export const STORE_KEY = 'store:key:'
export const STORE_CATEGORY_GEM = 'store:category:gem'

export const STORE_BONUS_TAG_RE = /^store:bonus-(\d\d?)p$/
export const STORE_DISCOUNT_TAG_RE = /^store:discount-(\d\d?)p$/
